if (!window.Eurus.loadedScript.has('quantity-selector.js')) {
  window.Eurus.loadedScript.add('quantity-selector.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xQuantitySelector', (
        productId,
        sectionId,
        qtyRuleMin,
        qtyRuleMax,
        isQtyRule,
        currencyCodeEnable,
        moneyWithCurrency,  
        moneyFormat
      ) => ({
        qty: qtyRuleMin,
        min: qtyRuleMin,
        max: qtyRuleMax,
        initQtyChangeEvent(selector) {
          console.log(selector);
          this.$nextTick(() => { 
            this.qty = document.getElementById(selector)?.value;
            window.currentQty = this.qty;
            this.updatePricePerMetre(this.qty);
            document.addEventListener(`eurus:product:quantity-changed-${sectionId}`, (e) => {
              this.qty = e.detail.quantity;
            })
          });
        },
        minus(value) {
          if(this.qty <= this.min) {
            this.qty = this.min;
          } else {
            this.qty = parseInt(this.qty);
            (this.qty == 1) ? this.qty = 1 : this.qty -= value;
          }
          window.currentQty = this.qty;
          this.updatePricePerMetre(this.qty);
          this.updatePrice();
        },
        plus(value) {
          if(this.qty >= this.max && isQtyRule) {
            this.qty = parseInt(this.max);
          } else {
            this.qty = parseInt(this.qty);
            this.qty += value;
          }
          window.currentQty = this.qty;
          this.updatePricePerMetre(this.qty);
          this.updatePrice();
        },

        onQtyChange(qty) {
          
          this.qty = document.querySelector('input[name="quantity"].buy-btn-qty-input').value;
          window.currentQty = this.qty;
          this.updatePricePerMetre(this.qty);
          this.updatePrice();
        },

        updatePricePerMetre(qty) {
          const price_per_metre = document.querySelector('.price-per-metre p');
          const length_fieldSet = document.querySelectorAll('.product-info fieldset')[1];
          const selectedLength = length_fieldSet.querySelector('input[type="radio"]:checked').value.replace('metres', '');
          const total_metres = qty * selectedLength;
          if (price_per_metre && total_metres) {
            const total_price = (qty * window.currentPrice).toFixed(2);
            price_per_metre.innerHTML = `Your total qty selected equals <b>${total_metres.toFixed(2)} meters</b> for a total price of <b>£${total_price}</b>`;
          }
        },

        invalid(el) {
          number = parseFloat(el.value);
          if (!Number.isInteger(number) || number < this.min) {
            this.qty = this.min;
          }
          if (number > this.max && isQtyRule) {
            this.qty = parseInt(this.max);
          }
          this.updatePrice();
        },
        updatePrice() {
          const product_template = document.getElementById(`x-product-template-${productId}-${sectionId}`);
          const money_format = currencyCodeEnable ? moneyWithCurrency : moneyFormat;

          const getPrice = (selector) => {
            return Number(product_template.querySelector(selector).innerHTML) * this.qty;
          };
          const update = (selector, value) => {
            const el = product_template.querySelector(selector);
            if (el) el.innerHTML = value;
          };

          let product_price = Alpine.store('xHelper').formatMoney(getPrice('.target-price'), money_format);
          let product_compare_at_price = Alpine.store('xHelper').formatMoney(getPrice('.target-compare-at-price'), money_format);

          update('.add_to_cart_button .main-product-price .price', product_price);
          update('.add_to_cart_button .main-product-price .price-sale', product_price);
          update('.add_to_cart_button .main-product-price .price-compare', product_compare_at_price);
        }
      }));
    })
  });
}    